import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/** 4xx responses are deterministic — retrying them only burns rate limit. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (ApiError.is(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
